module.exports = __webpack_public_path__ + "themes/mf/img/flake@2x.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/flake@2x.png
// module id = 74
// module chunks = 3